import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../../../shared/components/Header';
import { Footer } from '../../../shared/components/Footer';
import { Text  } from "@gs-ux-uitoolkit-react/text";
import { Button } from "@gs-ux-uitoolkit-react/button";
import { Radio } from '@gs-ux-uitoolkit-react/radio';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export function MfaAttempts() {
    const { repId } = useParams<{ repId: string }>(); // Extract repId from the URL
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [currView, setCurrView] = useState<"send-mfa" | "enter-mfa">('send-mfa'); // State to manage the current view
    const [linkDeactivatedError, setLinkDeactivatedError] = useState<string | null>(null);
    const navigate = useNavigate(); // Initialize the navigate function
    const [mfaType, setMfaType] = useState<string | null>();

    useEffect(() => {
        const fetchData = async () => {
            if (repId) {
                let url = `/api/v2/advisors-invitations/${repId}/summary`;
                try {
                    const response = await axios.get(url);
                    setPhoneNumber(response.data.maskedPhoneNumber);
                } catch (error: any) {
                    if (error?.response?.data?.displayMessage) {
                        setLinkDeactivatedError(error?.response?.data?.displayMessage);
                    }
                }
            }
        };

        fetchData();
    }, [repId]);

    const handleSubmit = () => {
        const url = `/api/v2/advisors-invitations/${repId}/mfa-attempts?mfaType=${mfaType}`; // Add mfaType as a query parameter

        axios
            .post(url, { repId }) // Send only repId in the body if needed
            .then((response) => {
                if (typeof mfaType === 'string') {
                    localStorage.setItem('mfaType', mfaType);
                }
                navigate(`/advisor-invitations/${repId}/mfa-verification`); // Redirect to the mfa-verification page
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <>
            <Header />
            {linkDeactivatedError === "Your account is locked due to too many failed attempts. Please contact support." ? (
                <div className="bg-red-10 p-4 rounded w-full max-w-screen-md mx-auto mt-4">
                    <Text typography="textBody02Medium" color="red060" className="mb-2">
                        Error
                    </Text>
                    <Text typography="textBody02Regular" color="red060">
                        {linkDeactivatedError}
                    </Text>
                </div>
            ) : (
                <>
                    <div className="justify-between flex-1 flex flex-col min-[700px]:flex-row items-center px-16 py-16 xl:gap-72 lg:gap-24 md:gap-12 sm:gap-6">
                        <div className="self-stretch px-6 inline-flex justify-center items-center gap-2.5">
                            <Text typography="textSubtitle03Medium">For security purposes, please confirm your phone number to receive a one-time security code.</Text>
                        </div>
                    </div>

                    {currView === "send-mfa" && (
                        <>
                            <div className="flex flex-col px-16 gap-6">
                                <div className="self-stretch px-6 flex flex-col gap-2">
                                    <Text typography="textTitle03">Choose a verification method</Text>
                                    <Text typography="textBody02Regular">Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly.</Text>
                                </div>
                                <div className="self-stretch px-6 flex flex-col gap-3">
                                    <Text typography="textBody01Medium" color="colorTextNeutralBold">Text</Text>
                                    <div className="pl-4">
                                        <Radio name="mfaradio" size="lg" onClick={() => { setMfaType("daySms") }}>
                                            {phoneNumber}
                                        </Radio>
                                    </div>
                                </div>
                                <div className="self-stretch px-6 flex flex-col gap-3">
                                    <Text typography="textBody01Medium" color="colorTextNeutralBold">Call</Text>
                                    <div className="pl-4">
                                        <Radio name="mfaradio" size="lg" onClick={() => { setMfaType("dayCall") }}>
                                            {phoneNumber}
                                        </Radio>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 mt-6 px-20 py-4 bg-gray-10">
                                <Button
                                    className="bg-blue-60 rounded"
                                    size="lg"
                                    type="submit"
                                    onClick={handleSubmit}
                                    appearance="neutral"
                                >
                                    Continue
                                </Button>
                            </div>
                        </>
                    )}

                    {currView === "enter-mfa" && (
                        <>
                            <div className="flex flex-col px-16 ">
                                <div className="self-stretch px-6 py-6 inline-flex gap-2.5">
                                    <Text typography="textBody04Regular">Choose a verification method</Text>
                                </div>
                                <div className="self-stretch px-6 pb-2 inline-flex gap-2.5">
                                    <Text typography="textBody02Regular">Check your 'Spam' or 'Unknown Senders' folder if the SMS code does not arrive shortly. </Text>
                                </div>
                                <div className="self-stretch px-6 inline-flex">
                                    <Radio defaultChecked>{phoneNumber}</Radio>
                                </div>
                            </div>
                            <div className="col-span-12 mt-4 px-20 py-4 bg-gray-10">
                                <Button
                                    className="bg-blue-60 rounded"
                                    size="lg"
                                    type="submit"
                                    onClick={handleSubmit} 
                                    appearance="neutral"
                                >
                                    Send Code
                                </Button>
                            </div>
                        </>
                    )}
                </>
            )}
            <Footer/>
        </>
    );
};
